module.exports = __webpack_public_path__ + "src/img/up-red.987847e6.svg";